import Parse from "/server/parse-server.js";
import { LocationObject } from "/server/parse-location.js";


export function filterAvailability(menus) {
    var filteredMenus = [];
    for (const menu of menus) {
        const availability = menu.availability
        if (availability.alwaysAvailable == true) {
            filteredMenus.push(menu);
        } else {
            // Filter based on time
            const schedule = availability.schedule;
            const good = isMenuAvailable(schedule);
            if (good == true) { filteredMenus.push(menu); }
        }
    }
    return filteredMenus;
}

function isMenuAvailable(availability, currentDate = new Date()) { // "2025-10-28T17:30:00"
  if (!Array.isArray(availability) || availability.length === 0) return true; // assume always available if no rules

  // Convert JS day index (0=Sunday) to Toast day name
  const dayNames = [
    'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY',
    'THURSDAY', 'FRIDAY', 'SATURDAY'
  ];
  const currentDay = dayNames[currentDate.getDay()];
  const currentMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();
  return availability.some(block => {
    if (!block.days.includes(currentDay)) return false;

    // If day matches, check time ranges
    return block.timeRanges.some(range => {
      const [startH, startM] = range.start.split(':').map(Number);
      const [endH, endM] = range.end.split(':').map(Number);
      const startMinutes = startH * 60 + startM;
      const endMinutes = endH * 60 + endM;

      // Handles wrap-around (e.g., 22:00–02:00)
      if (endMinutes < startMinutes) {
        return currentMinutes >= startMinutes || currentMinutes <= endMinutes;
      }

      return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
    });
  });
}

export function filterVisibility(items) {
    const filteredData = items.filter(item => {
        return item.visibility.includes('TOAST_ONLINE_ORDERING');
    });
    return filteredData;
}

export function removeUnavailableItems(stocks, locationObject) {
    const currentUser = Parse.User.current();
    if (currentUser != null) {
        const orderCheck = currentUser.get('orderCheck');
        if (orderCheck != null) {
            const checks = orderCheck.checks;
            if (checks != null) {
                
                const check = checks[0];
                const selections = check.selections;

                var removeIndexes = [];
                for (let i = selections.length - 1; i >= 0; i--) {
                    const selection = selections[i];

                    // Items that are out of stock
                    const stock = getStockStatus(selection.item.guid, stocks);
                    let status = stock.status;
                    if (status == "OUT_OF_STOCK") {
                        removeIndexes.push(i);
                    }

                    // Items not available at this time
                    const groupGuid = selection.itemGroup.guid;
                    const menu = getParentMenuByGroupGuid(groupGuid);
                    if (menu != null) {
                        const availability = menu.availability;
                        if (availability.alwaysAvailable == false) {
                            const schedule = availability.schedule;
                            const good = isMenuAvailable(schedule);
                            if (good == false) { removeIndexes.push(i); }
                        }
                    }
                }

                // Items that are not at this location
                const menus = JSON.parse(sessionStorage.getItem('toastMenus'));
                const toastMenuObject = {"menus": menus};
                const availableGuids = indexMenuItemGuids(toastMenuObject);

                let unavailableItems = selections.filter(i => !availableGuids.has(i.item.guid));
                if (unavailableItems != null) {
                    if (unavailableItems.length > 0) {
                        for (const unavailableItem of unavailableItems) {
                            const index = selections.findIndex(i => i.item.guid === unavailableItem.item.guid);
                            removeIndexes.push(index);
                        }
                    }
                }

                return removeIndexes;
            }
        }
    }
}

export function getStockStatus(itemGuid, stocks) {
    var stockJson = {};
    stockJson.status = "IN_STOCK";
    const stock = stocks.find(obj => obj.guid === itemGuid);
    if (stock != null) {
        return stock;
    }
    return stockJson;
}

export function storeMenuData(toastMenuObject) {
    const menus = filterVisibility(toastMenuObject.menus);
    sessionStorage.setItem('toastMenus', JSON.stringify(menus));
    const modifierGroups = toastMenuObject.modifierGroupReferences;
    sessionStorage.setItem('toastModifierGroups', JSON.stringify(modifierGroups));
    const modifiers = toastMenuObject.modifierOptionReferences;
    sessionStorage.setItem('toastModifiers', JSON.stringify(modifiers));
}

export function storeSchoolMenuData(toastMenuObject) {
    const SCHOOL_LUNCH_MENU_GUID = '9cca40b6-7ce4-458a-bb22-7056785b206c';
    const allMenus = toastMenuObject.menus;
    const schoolMenu = allMenus.find(m => m.guid === SCHOOL_LUNCH_MENU_GUID);
    sessionStorage.setItem('toastSchoolMenus', JSON.stringify(schoolMenu));
}

export async function getToastItem(groupGuid, itemGuid) {
    var menus = JSON.parse(sessionStorage.getItem('toastMenus'));
    if (menus == null) {
        const locationObject = await LocationObject();
        const toastGuid = locationObject.get('guid');
        const parseMenu = await Parse.Cloud.run('loadToastMenu', {'restaurantGuid': toastGuid});
        const toastMenuObject = parseMenu.get('object');
        storeMenuData(toastMenuObject);
        menus = filterVisibility(toastMenuObject.menus);
    }
    if (menus != null) {
        for (const menu of menus) {
            const groups = menu.menuGroups;
            const group = groups.find(obj => obj.guid === groupGuid);
            if (group != null) {
                const items = group.menuItems;
                const item = items.find(obj => obj.guid === itemGuid);
                if (item != null) { return item; }
            }
        }
    }
    return null;
}

export async function getToastGroup(groupGuid) {
    var menus = JSON.parse(sessionStorage.getItem('toastMenus'));
    if (menus == null) {
        const locationObject = await LocationObject();
        const toastGuid = locationObject.get('guid');
        const parseMenu = await Parse.Cloud.run('loadToastMenu', {'restaurantGuid': toastGuid});
        const toastMenuObject = parseMenu.get('object');
        storeMenuData(toastMenuObject);
        menus = filterVisibility(toastMenuObject.menus);
    }
    if (menus != null) {
        for (const menu of menus) {
            const groups = menu.menuGroups;
            const group = groups.find(obj => obj.guid === groupGuid);
            if (group != null) {
                return group;
            }
        }
    }
    return null;
}

function getParentMenuByGroupGuid(groupGuid, menusData) {
    var menus = JSON.parse(sessionStorage.getItem('toastMenus'));
    if (menus != null) {
        for (const menu of menus) {
            if (!menu.menuGroups) continue;
            const foundGroup = menu.menuGroups.find(g => g.guid === groupGuid);
            if (foundGroup) { return menu; }
        }
    }
    return null; // not found
}

export function indexMenuItemGuids(menuData, set = new Set()) {
  if (Array.isArray(menuData.menuItems)) {
    for (const item of menuData.menuItems) set.add(item.guid);
  }
  if (Array.isArray(menuData.menuGroups)) {
    for (const group of menuData.menuGroups) indexMenuItemGuids(group, set);
  }
  if (Array.isArray(menuData.menus)) {
    for (const subMenu of menuData.menus) indexMenuItemGuids(subMenu, set);
  }
  return set;
}

